export default "__VITE_ASSET__DQHGOUIp__"